/*
 * Authors: mariushirjanu
 * Created: 24/11/2023
 */
import { InjectionToken } from '@angular/core';
import { ConsoleTransporterService } from './console-transporter.service';
import { MemoryTransporterService } from './memory-transporter.service';

export const TransporterToken = new InjectionToken('transporter');

// here can be added as many transporters are needed
export const TRANSPORTER_PROVIDERS = [
  // provide Console transporter
  { provide: TransporterToken, useClass: ConsoleTransporterService, multi: true },

  // provide Memory Storage Transporter
  { provide: TransporterToken, useClass: MemoryTransporterService, multi: true }
];